export default __webpack_public_path__ + "static/media/hanaWalletIcon.4d2ad2cb.svg";